import { Reveal } from "./Reveal";
import { PARTNERS } from "../../data/siteData";

const LogoChip = ({ name }) => (
  <div
    className="shrink-0 mx-3 flex items-center justify-center px-8 py-4 rounded-xl glass min-w-[180px] group"
    data-testid={`partner-${name.toLowerCase().replace(/\s/g, "-")}`}
  >
    <span className="text-lg font-display font-bold tracking-wide text-slate-400 group-hover:text-[#00D4FF] transition-colors duration-300">
      {name}
    </span>
  </div>
);

export const TrustedBy = () => (
  <section className="relative bg-[#050F22] py-14 border-y border-white/5" data-testid="trusted-by-section">
    <div className="container-custom">
      <Reveal>
        <p className="text-center text-xs font-semibold uppercase tracking-[0.25em] text-slate-500 mb-10">
          Trusted By Industry Partners — carriers, NBN &amp; infrastructure
        </p>
      </Reveal>
    </div>
    <div className="marquee-mask relative overflow-hidden">
      <div className="marquee-track">
        {[...PARTNERS, ...PARTNERS].map((name, i) => (
          <LogoChip key={i} name={name} />
        ))}
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050F22] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050F22] to-transparent" />
    </div>
  </section>
);
